import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { EmailSettings } from "schemas/email";
import { ALL } from "schemas/forms";

import TemplateScreen from "components/TemplateScreen";
import { Template } from "features/Influencer/ContactList/schema";

import { BulkSendState } from "../schema";

interface Props {
  state: BulkSendState;
  setTemplates: (templates: Template[]) => void;
  renderTimePickedOption: () => JSX.Element;
  allEmailSettings: EmailSettings[];
}

interface SectionCardProps {
  iconClass: string;
  iconColor: string;
  iconBg: string;
  title: string;
  subtitle: string;
  children: ReactNode;
}

const SectionCard = ({
  iconClass,
  iconColor,
  iconBg,
  title,
  subtitle,
  children,
}: SectionCardProps) => (
  <Box
    sx={{
      backgroundColor: "white",
      border: "1px solid #e5e7eb",
      borderRadius: "14px",
      p: 2.5,
      mb: 2,
    }}
  >
    <Box sx={{ display: "flex", gap: 1.5, alignItems: "center", mb: 2 }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "10px",
          backgroundColor: iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Box
          component="i"
          className={iconClass}
          sx={{ fontSize: 18, color: iconColor }}
        />
      </Box>
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 18,
            color: "text.primary",
            lineHeight: "24px",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{ fontSize: 13, color: "text.secondary", lineHeight: "18px" }}
        >
          {subtitle}
        </Typography>
      </Box>
    </Box>
    {children}
  </Box>
);

const MainDialogBody = ({
  state,
  setTemplates,
  renderTimePickedOption,
  allEmailSettings,
}: Props) => {
  const { fallbackTemplates } = state;

  return (
    <>
      <SectionCard
        iconClass="fa-regular fa-envelope"
        iconColor="#1976d2"
        iconBg="#e8f4fd"
        title="Email Templates"
        subtitle="Choose the outreach and follow-up templates for this send"
      >
        <TemplateScreen
          templates={fallbackTemplates}
          setTemplates={setTemplates}
          category={ALL}
          allEmailSettings={allEmailSettings}
        />
      </SectionCard>

      <SectionCard
        iconClass="fa-regular fa-calendar"
        iconColor="#166534"
        iconBg="#dcfce7"
        title="Schedule"
        subtitle="Bento spreads emails through your chosen window on business days"
      >
        {renderTimePickedOption()}
      </SectionCard>
    </>
  );
};

export default MainDialogBody;
